import Slider from 'rc-slider';
import { Col, Row } from 'react-bootstrap';
import { useItemAnalysisContext } from '../utils/itemAnalysisContext';
import DropDownSelect from '../../../../../../src/components/DropDownSelect/index';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const AssignmentSelects = ({loadClassAssignments}) => {

  const [cmp1Key, setCmp1Key] = useState(new Date().getTime().toString());
  const [cmp2Key, setCmp2Key] = useState(new Date().getTime().toString());
  const [cmp3Key, setCmp3Key] = useState(new Date().getTime().toString());
  const [cmp4Key, setCmp4Key] = useState(new Date().getTime().toString());
  const [cmp5Key, setCmp5Key] = useState(new Date().getTime().toString());

  const { masteryScore, setMasteryScore, assignments
    , primaryAssignmentName, setPrimaryAssignmentName, primaryAssignmentId, setPrimaryAssignmentId, compare1Name, setCompare1Name, compare1Id, setCompare1Id
    , compare2Name, setCompare2Name, compare2Id, setCompare2Id, compare3Name, setCompare3Name, compare3Id, setCompare3Id, compare4Name, setCompare4Name
    , compare4Id, setCompare4Id, compare5Name, setCompare5Name, compare5Id, setCompare5Id
  } = useItemAnalysisContext();

  useEffect(() => {
    if(compare1Id==null)
    {
      setCmp1Key(new Date().getTime().toString());
    }
  }, [compare1Id]);

  useEffect(() => {
    if(compare1Id==null)
    {
      setCmp1Key(new Date().getTime().toString());
    }
  }, [compare1Id]);

  useEffect(() => {
    if(compare2Id==null)
    {
      setCmp2Key(new Date().getTime().toString());
    }
  }, [compare2Id]);

  useEffect(() => {
    if(compare3Id==null)
    {
      setCmp3Key(new Date().getTime().toString());
    }
  }, [compare3Id]);

  useEffect(() => {
    if(compare4Id==null)
    {
      setCmp4Key(new Date().getTime().toString());
    }
  }, [compare4Id]);

  useEffect(() => {
    if(compare5Id==null)
    {
      setCmp5Key(new Date().getTime().toString());
    }
  }, [compare5Id]);


  useEffect(() => {
    loadClassAssignments();
  }, []);

  const assignmentOnChange = (event, setName , setId)=>{
    var id = event.key;
    setId(Number(id));
    var selectedAssignment = assignments.find(x=>x.id==id);
    if(selectedAssignment) 
      setName(selectedAssignment.originalName);
  };

  return (
    <div className='p-4 fs-14'>
      <Row className='mb-3'><Col><label className='fw-medium'>Select a Primary Assignment</label></Col></Row>
      <Row className='mb-3'>
        <Col>
          <label className='pb-2'>Assignment</label>
          <DropDownSelect
            value={assignments}
            selectedId={primaryAssignmentId}
            dropdownId="primaryAssignment"
            selectedName={primaryAssignmentName}
            onChange={(e)=>assignmentOnChange(e,setPrimaryAssignmentName, setPrimaryAssignmentId)}
          />
        </Col>
        <Col>
          <Row className='pb-2'>
            <Col className='d-flex justify-content-between'>
              <label className='align-items-center d-flex'>{'Mastery Score'}</label>
            </Col>
          </Row>
          <Row>
            <Col className="sliding-bar pt-2 col-9">
              <Slider
                min={1}
                max={100}
                value={masteryScore}
                onChange={(e) => setMasteryScore(Number(e))}
                marks={{ 1: 1, 100: 100 }}
              />
            </Col>
            <Col>
              <input
                type="text"
                value={masteryScore}
                className="form-control text-lg-center text-secondary"
                id="masteryScore"
                disabled={true}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      {primaryAssignmentId > 0 && <Row>
        <Col>
          <Row className='mb-3'><Col><label className='fw-medium'>Choose Assignments to Compare (Optional)</label></Col></Row>
          <Row className='mb-3'>
            <Col>
              <label className='pb-2'>Compare #1</label>
              <DropDownSelect
                key={cmp1Key}
                value={assignments.filter(x=> x.id ==0 || ![primaryAssignmentId, compare2Id??0, compare3Id??0, compare4Id??0, compare5Id??0].includes(x.id))}
                selectedId={compare1Id}
                dropdownId="compare1"
                onChange={(e)=>assignmentOnChange(e,setCompare1Name, setCompare1Id)}
                selectedName={compare1Name}
              />
            </Col>
            <Col>
              <label className='pb-2'>Compare #2</label>
              <DropDownSelect
                key={cmp2Key}
                value={assignments.filter(x=> x.id ==0 ||![primaryAssignmentId, compare1Id??0, compare3Id??0, compare4Id??0, compare5Id??0].includes(x.id))}
                selectedId={compare2Id}
                dropdownId="compare2"
                selectedName={compare2Name}
                onChange={(e)=>assignmentOnChange(e,setCompare2Name, setCompare2Id)}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col>
              <label className='pb-2'>Compare #3</label>
              <DropDownSelect
                key={cmp3Key}
                value={assignments.filter(x=> x.id ==0 ||![primaryAssignmentId, compare1Id??0, compare2Id??0, compare4Id??0, compare5Id??0].includes(x.id))}
                selectedId={compare3Id}
                dropdownId="compare3"
                selectedName={compare3Name}
                onChange={(e)=>assignmentOnChange(e,setCompare3Name, setCompare3Id)}
              />
            </Col>
            <Col>
              <label className='pb-2'>Compare #4</label>
              <DropDownSelect
                key={cmp4Key}
                value={assignments.filter(x=> x.id ==0 ||![primaryAssignmentId, compare1Id??0, compare2Id??0, compare3Id??0, compare5Id??0].includes(x.id))}
                selectedId={compare4Id}
                dropdownId="compare4"
                selectedName={compare4Name}
                onChange={(e)=>assignmentOnChange(e,setCompare4Name, setCompare4Id)}
              />
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col className='col-6'>
              <label className='pb-2'>Compare #5</label>
              <DropDownSelect
                key={cmp5Key}
                value={assignments.filter(x=> x.id ==0 ||![primaryAssignmentId, compare1Id??0, compare2Id??0, compare3Id??0, compare4Id??0].includes(x.id))}
                selectedId={compare5Id}
                dropdownId="compare5"
                selectedName={compare5Name}
                onChange={(e)=>assignmentOnChange(e,setCompare5Name, setCompare5Id)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      }
    </div>
  );
};

AssignmentSelects.propTypes = {
  loadClassAssignments :PropTypes.func
};
export default AssignmentSelects;